import { render, staticRenderFns } from "./LearningQuiz.vue?vue&type=template&id=489562a6&"
import script from "./LearningQuiz.vue?vue&type=script&lang=js&"
export * from "./LearningQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports